import script from "./OpenButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenButton.vue?vue&type=script&lang=ts&setup=true"

import "./OpenButton.vue?vue&type=style&index=0&id=ebbd7ab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebbd7ab0"]])

export default __exports__